<template>
    <app-page-options-list :options="options" />
</template>
<script>
import PageOptionsList from '../UI/Controls/PageOptions/PageOptionsList.vue';
export default {
    components: {
        appPageOptionsList: PageOptionsList
    },
    data(){
        return {
            options: [
                { to: 'itemTypesPage', label: 'Tipos de Item' },
                { to: 'itemsPage', label: 'Items' },
                { to: 'assignItemToTheClientPage', label: 'Asignación de Item al cliente'}
            ]
        }
    }
}
</script>